// DEPENDENCIES
import dayjs from "dayjs";

// DATE MANIPULATION
export const getDate = () => {
	return dayjs().format("YYYY-MM-DD");
};

export const getDateTime = () => {
	return dayjs().format("YYYY-MM-DD HH:mm:ss");
};

// Get oldest date in system (year that J2 was founded)
export const getOldestDate = () => {
	return dayjs("2007-01-01").format("YYYY-MM-DD HH:mm:ss");
};

// This actually converts the date to local time
export const convertToPST = (date) => {
	return dayjs(date).format("MMM DD, YYYY hh:mm A");
};

export const convertToPSTYearOnly = (date) => {
	return dayjs(date).format("YYYY");
};

export const getCurrentTimeUTC = () => {
	return dayjs().utc().format("YYYY-MM-DD HH:mm:ss");
};

// This converts the date to local time with seconds
export const convertToPSTWithSeconds = (date) => {
	return dayjs(date).format("MMM DD, YYYY hh:mm:ss A");
};

export const getYear = () => {
	return dayjs().format("YYYY");
};
